/* global debounce */

/*
 * Strakker zoeken (LEDPLANET): elk woord moet in de titel (begin van een woord), de tags of
 * het producttype voorkomen. Zonder dit zoekt Shopify veel te breed (ook in beschrijvingen
 * en FAQ's) en toont het tot 1000 treffers.
 * - Stopwoordjes (voor, met, en, ...) worden genegeerd, en ook "led" (alle artikelen zijn LED).
 * - "A of B" wordt een keuze tussen A en B (in elke winkeltaal: of, oder, or, ou, o, lub).
 * - Maten worden gelijkgetrokken (zie maatTekst), zodat "62 x 62", "62x62cm" en "620x620" hetzelfde vinden.
 * - 03-11-2026: eenheden gelijktrekken ("12 volt", "12 V", "12vdc" = 12v; "72 watt" = 72w; "3000 kelvin" = 3000k),
 *   losse eenheidswoorden (volt, watt, kelvin) tellen niet mee.
 * - 03-11-2026: synoniemenlijst in alle winkeltalen (zie SYNONIEMEN: Netzteil, Treiber, zasilacz -> voeding/driver;
 *   Deckenleuchte -> plafond; Bewegungsmelder -> sensor ...), en meervoud vindt ook enkelvoud (lampen -> lamp*).
 * - 03-11-2026: de omgezette zoekopdracht (title:... OR tag:...) komt nooit meer in beeld; staat die
 *   ergens in (bv. een zoeksuggestie van Shopify), dan wordt eerst de gewone zoekterm teruggehaald.
 * - 03-11-2026: niets gevonden? Eerst breed zoeken, en is ook dat leeg, dan producten die op
 *   zoveel mogelijk van de woorden lijken (beste eerst).
 * - Ook de live resultaten tijdens het typen gebruiken de gelijkgetrokken maat en eenheid.
 * Dit geldt voor: alle zoekformulieren (Enter / zoekknop) en alle links naar /search?q=...
 * (recent gezocht, suggesties, "alle resultaten").
 */
(function () {
  if (window.lpStrikt) return;

  // Stopwoordjes en het "of"-woord per winkeltaal (taal van de pagina: nl, de, en, fr, es, it, pl).
  var STOP_PER_TAAL = {
    nl: ['en', 'voor', 'met', 'de', 'het', 'een', 'in', 'op', 'van', 'aan', 'te', 'naar', 'bij', 'die', 'dat'],
    de: ['und', 'für', 'fur', 'mit', 'der', 'die', 'das', 'ein', 'eine', 'im', 'in', 'auf', 'von', 'zu', 'bei'],
    en: ['and', 'for', 'with', 'the', 'a', 'an', 'in', 'on', 'of', 'to', 'at'],
    fr: ['et', 'pour', 'avec', 'le', 'la', 'les', 'un', 'une', 'en', 'de', 'du', 'des', 'au', 'aux', 'sur'],
    es: ['y', 'para', 'con', 'el', 'la', 'los', 'las', 'un', 'una', 'en', 'de', 'del', 'al'],
    it: ['e', 'per', 'con', 'il', 'lo', 'la', 'i', 'gli', 'le', 'un', 'una', 'in', 'di', 'da', 'del', 'della'],
    pl: ['i', 'oraz', 'dla', 'z', 'ze', 'w', 'we', 'na', 'do', 'od']
  };
  var OF_PER_TAAL = { nl: 'of', de: 'oder', en: 'or', fr: 'ou', es: 'o', it: 'o', pl: 'lub' };
  var TAAL = String((document.documentElement && document.documentElement.lang) || 'nl').toLowerCase().slice(0, 2);
  if (!STOP_PER_TAAL[TAAL]) TAAL = 'nl';
  // losse eenheidswoorden zonder getal ervoor zeggen niets ("12 volt" wordt eerst 12v)
  var EENHEID_WOORD = ['volt', 'volts', 'watt', 'watts', 'kelvin', 'v', 'w', 'k'];
  var STOP = ['led', 'leds'].concat(EENHEID_WOORD, STOP_PER_TAAL[TAAL]);
  var OF = OF_PER_TAAL[TAAL];
  var VEILIG = /^[\p{L}\p{N}][\p{L}\p{N}\-._]*$/u;

  /*
   * Synoniemenlijst (03-11-2026), in alle winkeltalen: nl, de, en, fr, es, it, pl, plus spreektaal en meervoud.
   * Shopify zoekt alleen in de Nederlandse titels. Daarom heeft elke groep:
   *   t = woorden die precies zo in de titels staan (Shopify zoekt op hele woorden, dus exact: warmwit, kaarslamp),
   *   s = alles wat een klant kan typen (vertalingen, spreektaal); die wijzen naar de groep.
   * Hoofdletters en accenten maken niet uit (glühbirne = gluhbirne). Langere woorden vinden hun groep
   * ook via het begin (deckenleuchten -> deckenleuchte, netzteile -> netzteil).
   * Uitbreiden: woord bij s van de juiste groep zetten. Nieuw titelwoord: bij t zetten.
   */
  var SYNONIEMEN = [
    // voedingen / drivers
    { t: ['voeding', 'stekkervoeding', 'driver'], s: ['voedingen', 'drivers', 'adapter', 'netzteil', 'netzteile', 'netzgerät', 'netzgerat', 'treiber', 'vorschaltgerät', 'vorschaltgerat', 'transformer', 'power', 'alimentation', 'transformateur', 'alimentatore', 'trasformatore', 'fuente', 'transformador', 'zasilacz', 'zasilacze', 'transformator', 'sterownik'] },
    // schijnwerpers / bouwlampen
    { t: ['schijnwerper', 'breedstraler', 'bouwlamp', 'verstraler', 'flood'], s: ['schijnwerpers', 'bouwlampen', 'breedstraler', 'floodlight', 'flood', 'fluter', 'strahler', 'scheinwerfer', 'baustrahler', 'flutlicht', 'projecteur', 'projector', 'foco', 'focos', 'proiettore', 'proiettori', 'faro', 'naświetlacz', 'naswietlacz', 'naświetlacze', 'halogenowiec'] },
    // werkverlichting
    { t: ['werklamp', 'werklicht', 'bouwlamp', 'inspectielamp'], s: ['werklampen', 'arbeitsleuchte', 'arbeitslampe', 'arbeitslicht', 'worklight', 'worklamp', 'baulampe', 'baustellenlampe', 'baustellenleuchte', 'travail', 'chantier', 'trabajo', 'obra', 'lavoro', 'cantiere', 'robocza', 'robocze', 'budowlana'] },
    // high bay / hallenverlichting
    { t: ['high', 'highbay', 'ufo'], s: ['highbay', 'hallenstrahler', 'hallenleuchte', 'hallenlampe', 'hallenbeleuchtung', 'industrielamp', 'industrieverlichting', 'magazijn', 'loods', 'werkplaats', 'industrie', 'industriel', 'industrial', 'warehouse', 'campana', 'cloche', 'industriale', 'przemysłowa', 'przemyslowa', 'hala', 'hali'] },
    // led strips
    { t: ['strip', 'strips', 'ledstrip'], s: ['ledstrips', 'lichtstrip', 'streifen', 'stripe', 'lichtband', 'lichtleiste', 'tape', 'ruban', 'bande', 'tira', 'tiras', 'cinta', 'striscia', 'strisce', 'nastro', 'taśma', 'tasma', 'taśmy', 'tasmy', 'pasek'] },
    // lichtslangen
    { t: ['lichtslang', 'lichtsnoer'], s: ['lichtslangen', 'slang', 'lichtschlauch', 'schlauch', 'rope', 'ropelight', 'cordon', 'tuyau', 'manguera', 'tubo luminoso', 'wąż', 'waz', 'wężyk', 'wezyk'] },
    // panelen
    { t: ['paneel', 'inbouwpaneel', 'opbouwpaneel', 'lijstpaneel'], s: ['panelen', 'panels', 'paneelverlichting', 'rasterleuchte', 'rasterlampe', 'deckenpanel', 'lichtpanel', 'panneau', 'dalle', 'panel', 'paneles', 'pannello', 'pannelli', 'panele', 'systeemplafond', 'kantoorverlichting'] },
    // downlights
    { t: ['downlight'], s: ['downlights', 'downlighters', 'einbauleuchte', 'einbauleuchten', 'deckeneinbauleuchte', 'encastré', 'encastre', 'empotrable', 'downlightów', 'downlightow'] },
    // spots
    { t: ['spot', 'spots', 'inbouwspot', 'inbouwspots', 'railspot', 'opbouwspot', 'wandspot'], s: ['spots', 'spotje', 'spotjes', 'spotlight', 'spotlights', 'einbaustrahler', 'einbauspot', 'spotleuchte', 'strahlerchen', 'faretto', 'faretti', 'focos', 'foco', 'oczko', 'oczka', 'spoty', 'reflektorek'] },
    // railsysteem
    { t: ['rail', 'railspot', 'railsysteem'], s: ['railsysteem', 'railverlichting', 'schiene', 'schienen', 'schienensystem', 'stromschiene', 'track', 'tracklight', 'carril', 'riel', 'binario', 'szyna', 'szynowy', 'szynowe'] },
    // inbouw / inbouwframes
    { t: ['inbouw', 'inbouwframe', 'inbouwspot', 'inbouwpaneel', 'frame'], s: ['inbouwframes', 'einbaurahmen', 'einbau', 'frame', 'cadre', 'encastrement', 'marco', 'cornice', 'incasso', 'ramka', 'oprawa', 'wpuszczana', 'podtynkowa'] },
    // opbouw
    { t: ['opbouw', 'opbouwpaneel', 'opbouwspot'], s: ['opbouwlamp', 'aufbau', 'aufputz', 'aufbauleuchte', 'surface', 'saillie', 'superficie', 'sopramuro', 'natynkowa', 'natynkowy'] },
    // armaturen / tri-proof
    { t: ['armatuur', 'proof', 'tri', 'bulkhead'], s: ['armaturen', 'armatur', 'armaturen', 'tri-proof', 'triproof', 'feuchtraumleuchte', 'feuchtraum', 'wannenleuchte', 'fixture', 'luminaire', 'réglette', 'reglette', 'luminaria', 'armadura', 'plafoniera stagna', 'stagna', 'hermetyczna', 'hermetyczny'] },
    // tl / buizen
    { t: ['tl', 'buis'], s: ['tlbuis', 'tl-buizen', 'tlbuizen', 'buizen', 'buisje', 'röhre', 'rohre', 'röhren', 'rohren', 'leuchtstoffröhre', 'leuchtstoffrohre', 'leuchtstofflampe', 't8', 'tube', 'tubes', 'néon', 'neon', 'tubo', 'tubi', 'świetlówka', 'swietlowka', 'świetlówki', 'swietlowki'] },
    // lineaire lichtbalk / led bar
    { t: ['lichtbalk', 'lineair', 'bar', 'bars'], s: ['lichtbalken', 'lichtlijn', 'lineaire', 'linear', 'lichtleiste', 'pendelleuchte linear', 'linéaire', 'lineaire', 'lineal', 'lineare', 'liniowa', 'liniowe', 'listwa'] },
    // lampen algemeen (algemeen: telt alleen mee als er verder niets gezocht wordt; "candle bulb E14" = kaarslamp E14)
    { t: ['lamp', 'lampen'], algemeen: true, s: ['lampen', 'lampje', 'lampjes', 'lampe', 'lampen', 'leuchte', 'leuchtmittel', 'leuchten', 'licht', 'bulb', 'bulbs', 'light', 'ampoule', 'ampoules', 'bombilla', 'bombillas', 'lámpara', 'lampara', 'lampada', 'lampadina', 'lampadine', 'żarówka', 'zarowka', 'żarówki', 'zarowki', 'lampa'] },
    // gloeilampen / peertjes
    { t: ['gloeilamp', 'globelamp', 'lamp'], s: ['peer', 'gloeilampen', 'peertje', 'peertjes', 'glühbirne', 'gluhbirne', 'glühbirnen', 'glühlampe', 'gluhlampe', 'birne', 'birnen', 'standard', 'a60'] },
    // filament / kooldraad / retro
    { t: ['filament', 'filamentlamp', 'kooldraadlamp', 'edisonlamp', 'vintage'], s: ['kooldraadlamp', 'gloeidraad', 'retro', 'edison', 'fadenlampe', 'glühfaden', 'gluhfaden', 'fadenleuchtmittel', 'filamento', 'filamenti', 'żarnik', 'zarnik', 'vintage'] },
    // kaarslampen
    { t: ['kaarslamp', 'flame', 'vlam', 'vlamsimulatie'], s: ['kaarslampen', 'kaarsje', 'kerzenlampe', 'kerze', 'kerzen', 'kerzenform', 'candle', 'bougie', 'flamme', 'vela', 'velas', 'candela', 'oliwka', 'świeczka', 'swieczka', 'świecowa', 'swiecowa'] },
    // kogellampen
    { t: ['kogellamp'], s: ['kogellampen', 'kogeltje', 'tropfen', 'tropfenlampe', 'tropfenform', 'golfball', 'golf', 'sphérique', 'spherique', 'esférica', 'esferica', 'sferica', 'sfera', 'kulka', 'kulista'] },
    // reflector / spiegellampen
    { t: ['reflectorlamp', 'spiegellamp'], s: ['reflectorlamp', 'spiegellampen', 'reflektorlampe', 'reflektor', 'spiegel', 'réflecteur', 'reflecteur', 'reflectora', 'riflettore', 'riflettente', 'odbłyśnik', 'odblysnik', 'par'] },
    // staaflampen / r7s
    { t: ['staaflamp', 'r7s'], s: ['staaflampen', 'stablampe', 'stab', 'stabförmig', 'crayon', 'lineal r7s', 'lineare r7s', 'pręt', 'pret'] },
    // halogeen / spaarlampen (vervangers)
    { t: ['halogeen', 'spaarlamp'], s: ['halogeenlamp', 'halogen', 'halogène', 'halogene', 'halógeno', 'halogeno', 'alogena', 'halogenowa', 'spaarlampen', 'energiesparlampe', 'sparlampe', 'energiezuinig', 'cfl', 'basse consommation', 'bajo consumo', 'risparmio', 'energooszczędna', 'energooszczedna'] },
    // dimmers
    { t: ['dimmer', 'snoerdimmer'], s: ['dimmers', 'dimschakelaar', 'dimknop', 'dimmerschalter', 'variateur', 'regulador', 'atenuador', 'dimmer', 'regolatore', 'ściemniacz', 'sciemniacz', 'regulator'] },
    // dimbaar
    { t: ['dimbaar', 'dimbare', 'triac', 'dali'], s: ['dimbare', 'dimmbar', 'dimmbare', 'dimmable', 'dimmerable', 'regulable', 'dimmerabile', 'dimmerabili', 'ściemnialna', 'sciemnialna', 'ściemnialne', 'sciemnialne'] },
    // schakelaars
    { t: ['schakelaar', 'schakelaars'], s: ['schakelaars', 'schalter', 'lichtschalter', 'switch', 'interrupteur', 'interruptor', 'interruttore', 'przełącznik', 'przelacznik', 'włącznik', 'wlacznik'] },
    // afstandsbedieningen
    { t: ['afstandsbediening', 'bediening'], s: ['afstandsbedieningen', 'bediening', 'fernbedienung', 'fernsteuerung', 'remote', 'controller', 'télécommande', 'telecommande', 'mando', 'telecomando', 'pilot', 'pilota', 'sterowanie'] },
    // sensoren / bewegingsmelders
    { t: ['sensor', 'bewegingssensor', 'daglichtsensor', 'nachtsensor', 'microgolfsensor', 'pir', 'detectie'], s: ['sensoren', 'bewegingsmelder', 'bewegingsensor', 'bewegingsdetector', 'pir', 'bewegungsmelder', 'bewegungssensor', 'melder', 'sensorlampe', 'motion', 'détecteur', 'detecteur', 'capteur', 'movimiento', 'sensore', 'sensori', 'czujnik', 'czujnikiem', 'schemersensor', 'dämmerungssensor', 'dammerungssensor', 'dusk', 'crépusculaire', 'crepuscular', 'crepuscolare', 'zmierzchowy', 'automatisch', 'automatische', 'automatic', 'automatique', 'automático', 'automatico', 'automatyczna', 'automatyczny'] },
    // noodverlichting
    { t: ['noodverlichting', 'noodlamp', 'noodstroommodule'], s: ['noodverlichting', 'noodlamp', 'noodlampen', 'nooduitgang', 'vluchtweg', 'notbeleuchtung', 'notleuchte', 'notlicht', 'sicherheitsbeleuchtung', 'notausgang', 'emergency', 'exit', 'secours', 'évacuation', 'evacuation', 'emergencia', 'salida', 'emergenza', 'uscita', 'awaryjna', 'awaryjne', 'ewakuacyjna', 'ewakuacyjne'] },
    // waterdicht
    { t: ['waterdicht', 'sproeidicht', 'plensdicht'], s: ['waterdichte', 'spatwaterdicht', 'wasserdicht', 'wasserfest', 'waterproof', 'étanche', 'etanche', 'impermeable', 'estanca', 'impermeabile', 'stagno', 'wodoodporna', 'wodoodporny', 'wodoszczelna', 'wodoszczelny', 'hermetyczna'] },
    // buiten / tuin
    { t: ['buiten', 'buitenlamp'], s: ['buitenlamp', 'buitenlampen', 'buitenverlichting', 'tuin', 'tuinlamp', 'tuinverlichting', 'aussen', 'außen', 'aussenleuchte', 'außenleuchte', 'aussenbeleuchtung', 'außenbeleuchtung', 'garten', 'gartenleuchte', 'outdoor', 'outside', 'garden', 'extérieur', 'exterieur', 'jardin', 'exterior', 'jardín', 'esterno', 'esterni', 'giardino', 'zewnętrzna', 'zewnetrzna', 'zewnętrzne', 'zewnetrzne', 'ogrodowa', 'ogrodowe', 'ogród', 'ogrod'] },
    // grondspots
    { t: ['grondspot', 'beloopbaar'], s: ['grondspots', 'grondlamp', 'grondverlichting', 'bodemspot', 'bodenstrahler', 'bodeneinbaustrahler', 'bodenleuchte', 'boden', 'ground', 'inground', 'encastrable sol', 'suelo', 'calpestabile', 'najazdowa', 'najazdowe', 'gruntowa'] },
    // straatverlichting
    { t: ['straatverlichting'], s: ['straatlamp', 'straatverlichting', 'lantaarnpaal', 'straatlantaarn', 'strassenlampe', 'straßenlampe', 'strassenleuchte', 'straßenleuchte', 'strassenbeleuchtung', 'straßenbeleuchtung', 'mastleuchte', 'street', 'streetlight', 'lampadaire', 'réverbère', 'reverbere', 'farola', 'farolas', 'lampione', 'stradale', 'uliczna', 'uliczne', 'latarnia'] },
    // stadionlampen
    { t: ['stadionlamp'], s: ['stadionlamp', 'stadionverlichting', 'sportveld', 'sportplatz', 'stadium', 'sports', 'stade', 'estadio', 'stadio', 'stadionowa', 'boisko'] },
    // accu / oplaadbaar / batterij
    { t: ['accu', 'oplaadbaar', 'oplaadbare', 'batterijen'], s: ['accus', 'batterijen', 'akku', 'akkus', 'aufladbar', 'wiederaufladbar', 'batterie', 'batterien', 'battery', 'rechargeable', 'cordless', 'batería', 'bateria', 'recargable', 'batteria', 'ricaricabile', 'akumulator', 'akumulatorowa', 'ładowalna', 'ladowalna', 'bateryjna'] },
    // lantaarns / zaklampen
    { t: ['lantaarn', 'campinglamp', 'tentlamp'], s: ['lantaarns', 'zaklampen', 'laterne', 'taschenlampe', 'campinglampe', 'lantern', 'flashlight', 'torch', 'lanterne', 'torche', 'linterna', 'farol', 'lanterna', 'torcia', 'latarka', 'latarnia'] },
    // solar
    { t: ['solar', 'zonnepaneel'], s: ['zonnelamp', 'zonne-energie', 'zonnepaneel', 'zonnecel', 'solarleuchte', 'solarlampe', 'solarlicht', 'sonne', 'solaire', 'solare', 'solares', 'solarna', 'solarne', 'słoneczna', 'sloneczna'] },
    // kweeklampen
    { t: ['kweeklamp', 'groei', 'bloei'], s: ['kweeklampen', 'groeilamp', 'kweken', 'grow', 'growlight', 'pflanzenlampe', 'pflanzenlicht', 'pflanzenleuchte', 'pflanzen', 'horticole', 'culture', 'cultivo', 'crecimiento', 'coltivazione', 'crescita', 'piante', 'uprawy', 'roślin', 'roslin'] },
    // plafondlampen
    { t: ['plafondlamp', 'opbouw', 'opbouwpaneel'], s: ['plafondlamp', 'plafondlampen', 'plafonnière', 'plafonniere', 'deckenleuchte', 'deckenlampe', 'deckenlicht', 'decke', 'ceiling', 'plafonnier', 'plafond', 'plafón', 'plafon', 'techo', 'plafoniera', 'soffitto', 'sufitowa', 'sufitowe', 'plafon'] },
    // hanglampen
    { t: ['hanglamp', 'hangend', 'pendel', 'ophangset'], s: ['hanglampen', 'pendellamp', 'pendelleuchte', 'pendellampe', 'hängelampe', 'hangelampe', 'hängeleuchte', 'hangeleuchte', 'pendant', 'hanging', 'suspension', 'suspendue', 'colgante', 'sospensione', 'wisząca', 'wiszaca', 'zwis'] },
    // fittingen
    { t: ['fitting', 'fittingen', 'verloopfitting', 'lampvoet', 'lamphouder'], s: ['fittingen', 'verloopfitting', 'lampvoet', 'sockel', 'fassung', 'lampenfassung', 'adapter', 'socket', 'base', 'culot', 'douille', 'casquillo', 'portalámparas', 'portalamparas', 'attacco', 'portalampada', 'trzonek', 'oprawka'] },
    // aansluitmateriaal
    { t: ['connector', 'verbinder', 'hoekverbinder', 'kruisverbinder', 'verbindingsklem', 'lasklem', 'aansluitmateriaal', 'aansluitkast'], s: ['connectoren', 'aansluiting', 'koppelstuk', 'verbinder', 'verbindungsstück', 'anschluss', 'klemme', 'connecteur', 'raccord', 'conector', 'empalme', 'connettore', 'złączka', 'zlaczka', 'złącze', 'zlacze'] },
    // stekkers
    { t: ['stekker', 'stekkersnoer'], s: ['stekkers', 'stecker', 'netzstecker', 'plug', 'fiche', 'prise', 'enchufe', 'clavija', 'spina', 'wtyczka', 'wtyk'] },
    // snoer / kabel
    { t: ['snoer', 'kabel', 'stekkersnoer'], s: ['snoeren', 'draad', 'bedrading', 'verlengsnoer', 'kabel', 'leitung', 'draht', 'cable', 'wire', 'cord', 'câble', 'fil', 'cordon', 'cavo', 'filo', 'przewód', 'przewod', 'kabel'] },
    // weerstanden
    { t: ['weerstand', 'resistor'], s: ['weerstanden', 'widerstand', 'lastwiderstand', 'resistor', 'résistance', 'resistance', 'resistencia', 'resistenza', 'rezystor', 'opornik'] },
    // koelkastlampjes
    { t: ['koelkastlamp'], s: ['koelkastlamp', 'koelkastlampje', 'kühlschrank', 'kuhlschrank', 'kühlschranklampe', 'fridge', 'refrigerator', 'réfrigérateur', 'refrigerateur', 'frigo', 'nevera', 'frigorífico', 'frigorifico', 'frigorifero', 'lodówka', 'lodowka'] },
    // nachtlampjes
    { t: ['nachtlampje'], s: ['nachtlampje', 'nachtlampjes', 'nachtlicht', 'nachtlampe', 'nightlight', 'night', 'veilleuse', 'quitamiedos', 'nocturna', 'notturna', 'lucina', 'lampka nocna', 'nocna'] },
    // onderwater / vijver
    { t: ['onderwaterlamp', 'vijver', 'fontein'], s: ['onderwaterlamp', 'vijverlamp', 'vijververlichting', 'zwembad', 'unterwasser', 'teich', 'teichbeleuchtung', 'pool', 'underwater', 'pond', 'subaquatique', 'bassin', 'piscine', 'sumergible', 'estanque', 'piscina', 'subacqueo', 'subacquea', 'laghetto', 'podwodna', 'podwodne', 'oczko wodne', 'basen'] },
    // auto
    { t: ['autolamp', 'canbus', 'koplampset', 'mistlamp', 'kentekenverlichting', 'dagrijverlichting', 'dashboardverlichting'], s: ['autolamp', 'autolampen', 'autoverlichting', 'kfz', 'pkw', 'fahrzeug', 'car', 'vehicle', 'voiture', 'coche', 'vehículo', 'vehiculo', 'macchina', 'samochód', 'samochod', 'samochodowa'] },
    // wifi / smart
    { t: ['wifi', 'slim', 'slimme', 'bluetooth'], s: ['wi-fi', 'wlan', 'smart', 'slim', 'slimme', 'app', 'tuya', 'alexa', 'google', 'intelligent', 'inteligente', 'intelligente', 'inteligentna', 'inteligentne'] },
    // kantelbaar
    { t: ['kantelbaar', 'draaibare', 'instelbaar'], s: ['kantelbare', 'draaibaar', 'verstelbaar', 'schwenkbar', 'drehbar', 'tiltable', 'adjustable', 'orientable', 'basculant', 'inclinable', 'orientabile', 'regolabile', 'uchylna', 'regulowana', 'obrotowa'] },
    // kleuren licht
    { t: ['warmwit'], s: ['warmwit', 'warmweiss', 'warmweiß', 'warmwhite', 'gezellig', 'chaud', 'cálido', 'calido', 'caldo', 'ciepła', 'ciepla', 'ciepłe', 'cieple'] },
    { t: ['koelwit'], s: ['koelwit', 'koudwit', 'kaltweiss', 'kaltweiß', 'kalt', 'kühl', 'kuhl', 'cool', 'cold', 'froid', 'frío', 'frio', 'freddo', 'zimna', 'zimne', 'chłodna', 'chlodna'] },
    { t: ['neutraalwit'], s: ['neutraalwit', 'neutralweiss', 'neutralweiß', 'neutral', 'neutre', 'neutro', 'neutra', 'neutralna', 'neutralne'] },
    { t: ['daglichtwit'], s: ['daglichtwit', 'tageslicht', 'tageslichtweiss', 'daylight', 'lumière du jour', 'jour', 'diurna', 'día', 'giorno', 'dzienna', 'dzienne'] },
    { t: ['rgb', 'rgbw', 'rgbwww', 'meerkleurig', 'kleuren', 'gekleurd', 'gekleurde'], s: ['rgbw', 'kleuren', 'gekleurd', 'kleurwissel', 'farbe', 'farbig', 'farbwechsel', 'bunt', 'colour', 'color', 'colored', 'couleur', 'couleurs', 'colores', 'colore', 'colorata', 'kolor', 'kolorowa', 'kolorowe'] },
    // kleuren behuizing
    { t: ['zwart'], s: ['zwarte', 'schwarz', 'schwarze', 'black', 'noir', 'noire', 'negro', 'negra', 'nero', 'nera', 'czarna', 'czarny', 'czarne'] },
    { t: ['wit'], s: ['witte', 'weiss', 'weiß', 'weisse', 'weiße', 'white', 'blanc', 'blanche', 'blanco', 'blanca', 'bianco', 'bianca', 'biała', 'biala', 'biały', 'bialy', 'białe', 'biale'] },
    { t: ['zilver', 'grijs', 'aluminiumlook'], s: ['zilveren', 'grijze', 'silber', 'grau', 'alu', 'silver', 'grey', 'gray', 'argent', 'gris', 'plata', 'argento', 'grigio', 'srebrna', 'srebrny', 'szara', 'szary'] },
    // vormen
    { t: ['rond'], s: ['ronde', 'rund', 'runde', 'round', 'circular', 'rond', 'ronde', 'redondo', 'redonda', 'rotondo', 'rotonda', 'okrągła', 'okragla', 'okrągły', 'okragly'] },
    { t: ['vierkant'], s: ['vierkante', 'quadratisch', 'eckig', 'square', 'carré', 'carre', 'cuadrado', 'cuadrada', 'quadrato', 'quadrata', 'kwadratowa', 'kwadratowy'] },
    // helder / mat
    { t: ['helder'], s: ['heldere', 'klar', 'clear', 'transparent', 'claire', 'clair', 'transparente', 'trasparente', 'chiaro', 'przezroczysta', 'przezroczysty'] },
    { t: ['mat'], s: ['matte', 'opaal', 'melkglas', 'matt', 'frosted', 'opal', 'mate', 'dépoli', 'depoli', 'opaco', 'satinato', 'matowa', 'matowy', 'mleczna'] },
    // sets / multipacks
    { t: ['set', 'stuks'], s: ['stuk', 'pak', 'pakket', 'voordeelpak', 'voordeelverpakking', 'multipack', 'stück', 'stuck', 'stk', 'packung', 'pack', 'pcs', 'pieces', 'lot', 'pièces', 'pieces', 'juego', 'piezas', 'pack', 'pezzi', 'confezione', 'sztuk', 'zestaw', 'komplet'] },
    // lichtkleuren / kleuren (titelwoorden: rood, groen, blauw, geel, oranje, paars, roze, amber)
    { t: ['rood'], s: ['rode', 'rot', 'rote', 'red', 'rouge', 'rojo', 'roja', 'rosso', 'rossa', 'czerwony', 'czerwona', 'czerwone'] },
    { t: ['groen'], s: ['groene', 'grün', 'grun', 'grüne', 'green', 'vert', 'verte', 'verde', 'zielony', 'zielona', 'zielone'] },
    { t: ['blauw'], s: ['blauwe', 'blau', 'blaue', 'blue', 'bleu', 'bleue', 'azul', 'blu', 'niebieski', 'niebieska', 'niebieskie'] },
    { t: ['geel', 'amber'], s: ['gele', 'gelb', 'gelbe', 'yellow', 'jaune', 'amarillo', 'amarilla', 'giallo', 'gialla', 'żółty', 'zolty', 'żółta', 'zolta', 'ambra', 'ámbar', 'bursztynowy'] },
    { t: ['oranje', 'amber'], s: ['orange', 'naranja', 'arancione', 'pomarańczowy', 'pomaranczowy'] },
    { t: ['paars'], s: ['paarse', 'lila', 'violett', 'purple', 'violet', 'violette', 'morado', 'morada', 'viola', 'fioletowy', 'fioletowa'] },
    { t: ['roze'], s: ['rosa', 'pink', 'rose', 'różowy', 'rozowy', 'różowa', 'rozowa'] },
    // flikkervrij
    { t: ['flikkervrij'], s: ['flimmerfrei', 'flackerfrei', 'flickerfree', 'flicker', 'scintillement', 'parpadeo', 'sfarfallio', 'migotania', 'migotanie'] },
    // koppelbaar
    { t: ['koppelbaar'], s: ['koppelbare', 'koppelen', 'doorkoppelbaar', 'verbindbar', 'koppelbar', 'kaskadierbar', 'linkable', 'connectable', 'raccordable', 'enlazable', 'conectable', 'collegabile', 'łączenia', 'laczenia'] },
    // binnen
    { t: ['binnenshuis', 'binnen'], s: ['innen', 'innenbereich', 'indoor', 'inside', 'intérieur', 'interieur', 'interior', 'interno', 'interna', 'wewnętrzna', 'wewnetrzna', 'wewnętrzne', 'wewnetrzne'] },
    // materialen
    { t: ['glas'], s: ['glass', 'verre', 'vidrio', 'cristal', 'vetro', 'szkło', 'szklo', 'szklana'] },
    { t: ['kunststof'], s: ['kunststoff', 'plastic', 'plastik', 'plastique', 'plástico', 'plastico', 'policarbonato', 'polycarbonate', 'tworzywo'] },
    { t: ['metalen', 'rvs', 'aluminiumlook'], s: ['metaal', 'metall', 'metal', 'métal', 'metallo', 'edelstahl', 'stainless', 'inox', 'acero', 'acciaio', 'nierdzewna', 'stal', 'aluminium', 'alu'] },
    // ventilator, mast, timer
    { t: ['ventilator'], s: ['lüfter', 'lufter', 'fan', 'ventilateur', 'ventilador', 'ventola', 'wentylator'] },
    { t: ['mast', 'mastadapter', 'mastadapters'], s: ['paal', 'lichtmast', 'mastbevestiging', 'mastmontage', 'pole', 'poteau', 'poste', 'palo', 'słup', 'slup'] }
  ];
  function zonderAccent(w) { return String(w).normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ł/g, 'l'); }
  var SYN_VAN = {};
  var SYN_SLEUTELS = [];
  var ALGEMEEN = {};
  SYNONIEMEN.forEach(function (groep) {
    groep.t.concat(groep.s).forEach(function (w) {
      if (/\s/.test(w)) return;   // woordgroepen (twee woorden) worden per woord gezocht en hier overgeslagen
      var k = zonderAccent(w.toLowerCase());
      if (!SYN_VAN[k]) { SYN_VAN[k] = []; SYN_SLEUTELS.push(k); }
      if (groep.algemeen) ALGEMEEN[k] = true;
      groep.t.forEach(function (t) { if (SYN_VAN[k].indexOf(t) < 0) SYN_VAN[k].push(t); });
    });
  });
  // titelwoorden voor een getypt woord: eerst precies, dan de stam, dan het langste bekende woord waarmee het begint
  function synVoor(w) {
    var k = zonderAccent(w), s = zonderAccent(stam(w));
    if (SYN_VAN[k]) return SYN_VAN[k];
    if (SYN_VAN[s]) return SYN_VAN[s];
    var best = '';
    for (var i = 0; i < SYN_SLEUTELS.length; i++) {
      var sl = SYN_SLEUTELS[i];
      if (sl.length >= 4 && sl.length > best.length && k.indexOf(sl) === 0) best = sl;
    }
    return best ? SYN_VAN[best] : [];
  }

  // meervoud: lampen -> lamp, spots -> spot, drivers -> driver (alleen langere woorden, en alleen als het woord geen getal bevat)
  function stam(w) {
    if (/\d/.test(w)) return w;
    if (w.length >= 6 && /en$/.test(w)) return w.slice(0, -2);
    if (w.length >= 5 && /[^s]s$/.test(w)) return w.slice(0, -1);
    return w;
  }
  // varianten voor één woord: het woord zelf, de stam en de titelwoorden van zijn groep(en)
  function varianten(w) {
    // los getal zonder eenheid: ook met de eenheden zoals ze in titels staan (72 vindt 72W, 12 vindt 12V, 3000 vindt 3000K)
    if (/^\d+$/.test(w)) return [w, w + 'w', w + 'v', w + 'k', w + 'a', w + 'mm', w + 'cm', w + 'm'];
    // lengte met eenheid: ook het losse getal, want titels schrijven vaak "120 cm" (120cm = 1200mm)
    var lengte = w.match(/^(\d+(?:\.\d+)?)(mm|cm|m)$/);
    if (lengte) {
      var getalW = parseFloat(lengte[1]), mm = lengte[2] === 'mm' ? getalW : lengte[2] === 'cm' ? getalW * 10 : getalW * 1000;
      return [w, lengte[1], netjes(mm / 10) + 'cm', netjes(mm) + 'mm'].filter(function (v, i, a) { return a.indexOf(v) === i; });
    }
    // Shopify zoekt in de winkel op hele woorden: daarom het getypte woord zelf, de stam (lampen -> lamp)
    // en de exacte titelwoorden van de groep, zonder ze in te korten.
    var lijst = [w];
    if (stam(w) !== w) lijst.push(stam(w));
    synVoor(w).forEach(function (s) { if (lijst.indexOf(s) < 0) lijst.push(s); });
    return lijst;
  }

  /*
   * Maten gelijktrekken (LEDPLANET): "62 x 62", "62x62cm", "62*62", "62×62", "620x620" en "620 x 620 mm"
   * worden allemaal dezelfde maat. Er wordt gezocht op de cm-vorm én de mm-vorm (62x62 of 620x620),
   * kleinste maat eerst (120x30 = 30x120). Ronde maten: "Ø12", "ø 120mm" en "Ø12cm" worden ø12 of ø120.
   */
  var MM_NAAR_CM = { 295: 30, 300: 30, 595: 60, 600: 60, 620: 62, 625: 62, 1195: 120, 1200: 120, 1495: 150, 1500: 150 };
  var CM_NAAR_MM = { 30: 300, 60: 600, 62: 620, 120: 1200, 150: 1500 };
  function getal(s) { return parseFloat(String(s).replace(',', '.')); }
  function netjes(n) { return String(Math.round(n * 10) / 10); }
  function naarCm(n, eenheid) { return eenheid === 'mm' ? (MM_NAAR_CM[n] || n / 10) : n; }
  function naarMm(n) { return CM_NAAR_MM[n] || n * 10; }
  function maatVormen(a, b, eenheid) {
    var cm = [naarCm(a, eenheid), naarCm(b, eenheid)].sort(function (x, y) { return x - y; });
    var mm = [naarMm(cm[0]), naarMm(cm[1])];
    return [netjes(cm[0]) + 'x' + netjes(cm[1]), netjes(mm[0]) + 'x' + netjes(mm[1])];
  }
  var MAATVORMEN = {};
  function maatTekst(raw) {
    var s = String(raw || '').toLowerCase();
    s = s.replace(/(\d+(?:[.,]\d+)?)\s*(cm|mm)?\s*[x×*]\s*(\d+(?:[.,]\d+)?)\s*(cm|mm)?(?![\p{L}\p{N}])/gu, function (m, a, e1, b, e2) {
      var x = getal(a), y = getal(b);
      var eenheid = e1 || e2 || (x >= 100 && y >= 100 ? 'mm' : 'cm');
      var vormen = maatVormen(x, y, eenheid);
      MAATVORMEN[vormen[0]] = vormen;
      return ' ' + vormen[0] + ' ';
    });
    s = s.replace(/[øØ]\s*(\d+(?:[.,]\d+)?)\s*(cm|mm)?(?![\p{L}\p{N}])/gu, function (m, a, e) {
      var x = getal(a);
      var eenheid = e || (x >= 100 ? 'mm' : 'cm');
      var cm = eenheid === 'mm' ? x / 10 : x;
      var vormen = ['ø' + netjes(cm), 'ø' + netjes(cm * 10)];
      MAATVORMEN[vormen[0]] = vormen;
      return ' ' + vormen[0] + ' ';
    });
    return eenheden(s);
  }

  // Eenheden gelijktrekken zoals ze in de titels staan: 12V, 72W, 3000K, 120cm, 5m.
  function eenheden(s) {
    var NA = '(?![\\p{L}\\p{N}])';
    return s
      .replace(new RegExp('(\\d+)\\s*(?:volts?|vdc|vac|v)' + NA, 'gu'), '$1v')
      .replace(new RegExp('(\\d+)\\s*(?:watts?|w)' + NA, 'gu'), '$1w')
      .replace(new RegExp('(\\d+)\\s*(?:kelvin|k)' + NA, 'gu'), '$1k')
      // lengtes: "120 cm" = 120cm, "5 meter" / "5 m" = 5m (zoekt daarna ook op het losse getal)
      .replace(new RegExp('(\\d+(?:\\.\\d+)?)\\s*(cm|mm)' + NA, 'gu'), '$1$2')
      .replace(new RegExp('(\\d+(?:\\.\\d+)?)\\s*(?:meters?|metres?|metros?|metri|metro|metr[yó]w|metr|m)' + NA, 'gu'), '$1m');
  }

  // Woordcombinaties die samen één begrip zijn (in alle talen), vóór het splitsen in losse woorden vervangen.
  var FRASEN = [
    [/\bpower\s+supply\b|\bpower\s+supplies\b|\bfuente\s+de\s+alimentaci[oó]n\b|\bbloc\s+d'?alimentation\b/g, 'voeding'],
    [/\bmotion\s+sensor\b|\bmotion\s+detector\b|\bsensor\s+de\s+movimiento\b|\bd[ée]tecteur\s+de\s+mouvement\b|\bsensore\s+di\s+movimento\b|\bczujnik\s+ruchu\b/g, 'sensor'],
    [/\bdusk\s+(?:to\s+)?dawn\b|\bdag[\s-]*nacht\b|\btag[\s-]*nacht\b/g, 'sensor'],
    [/\bflood\s*light\b/g, 'floodlight'], [/\bhigh\s*bay\b/g, 'highbay'], [/\btri[\s-]*proof\b/g, 'triproof'],
    [/\bstreet\s*light\b|\bstreet\s+lamp\b/g, 'straatlamp'], [/\bwork\s*light\b|\bwork\s+lamp\b/g, 'werklamp'],
    [/\bnight\s*light\b|\blampka\s+nocna\b/g, 'nachtlamp'], [/\bgrow\s*light\b/g, 'kweeklamp'],
    [/\brope\s*light\b|\btubo\s+luminoso\b|\btubo\s+led\s+flessibile\b/g, 'lichtslang'],
    [/\boczko\s+wodne\b/g, 'vijver'], [/\blumi[eè]re\s+du\s+jour\b|\bluz\s+d[ií]a\b|\bluce\s+diurna\b/g, 'daglicht'],
    [/\bbasse\s+consommation\b|\bbajo\s+consumo\b|\brisparmio\s+energetico\b/g, 'spaarlamp'],
    [/\bwarm\s+(?:white|wei(?:ss|ß)|wit)\b|\bblanc\s+chaud\b|\bblanco\s+c[aá]lido\b|\bbianco\s+caldo\b|\bciep[lł]a\s+biel\b|\bciep[lł]y\s+bia[lł]y\b/g, 'warmwit'],
    [/\b(?:cool|cold)\s+white\b|\bkalt\s*wei(?:ss|ß)\b|\bkoel\s+wit\b|\bkoud\s+wit\b|\bblanc\s+froid\b|\bblanco\s+fr[ií]o\b|\bbianco\s+freddo\b|\bzimna\s+biel\b|\bzimny\s+bia[lł]y\b/g, 'koelwit'],
    [/\bneutral\s+white\b|\bneutral\s*wei(?:ss|ß)\b|\bblanc\s+neutre\b|\bblanco\s+neutro\b|\bbianco\s+neutro\b|\bneutralna\s+biel\b/g, 'neutraalwit'],
    [/\bremote\s+control\b|\bmando\s+a\s+distancia\b|\bt[ée]l[ée]commande\b|\btelecomando\b|\bpilot\s+zdalnego\s+sterowania\b/g, 'afstandsbediening'],
    [/\bemergency\s+light(?:ing)?\b|\bluz\s+de\s+emergencia\b|\b[ée]clairage\s+de\s+secours\b|\bluce\s+di\s+emergenza\b|\boświetlenie\s+awaryjne\b|\boswietlenie\s+awaryjne\b/g, 'noodverlichting'],
    [/\bceiling\s+light\b|\bceiling\s+lamp\b/g, 'plafondlamp'], [/\bpendant\s+light\b|\bhanging\s+lamp\b/g, 'hanglamp'],
    [/\bsolar\s+(?:light|lamp|panel)\b/g, 'solar'], [/\bled\s*strip\b|\bled\s+tape\b/g, 'ledstrip']
  ];
  // woordgrenzen ook rond letters als ß, ł en é (\b in JavaScript kent die niet)
  FRASEN = FRASEN.map(function (f) {
    var bron = f[0].source.replace(/\\b/g, '');
    return [new RegExp('(^|[^\\p{L}\\p{N}])(?:' + bron + ')(?=$|[^\\p{L}\\p{N}])', 'gu'), f[1]];
  });
  function frasen(s) { FRASEN.forEach(function (f) { s = s.replace(f[0], function (m, voor) { return voor + f[1]; }); }); return s; }

  // Haalt uit een al omgezette zoekopdracht ("(title:driver* OR tag:driver ...) (title:12v* ...)") de gewone woorden terug.
  function ontSyntax(raw) {
    var s = String(raw || '');
    if (!/(title|tag|product_type)\s*:/i.test(s)) return s;
    var woorden = [];
    var groepen = s.match(/\([^()]*\)/g) || [s];
    groepen.forEach(function (g) {
      var m = g.match(/title:([^\s*()]+)/i);
      if (m && woorden.indexOf(m[1]) < 0) woorden.push(m[1]);
    });
    return woorden.join(' ');
  }
  window.lpOntSyntax = ontSyntax;

  // Zoekwoorden in groepen (elke groep = één woord met zijn varianten), of null als het niet veilig kan.
  function groepenVan(raw) {
    MAATVORMEN = {};
    var tokens = frasen(maatTekst(ontSyntax(raw))).trim().split(/\s+/).filter(Boolean);
    if (tokens.length === 0 || tokens.length > 8) return null;
    for (var i = 0; i < tokens.length; i++) { if (!VEILIG.test(tokens[i])) return null; }

    var groepen = [];
    var orVolgende = false;
    tokens.forEach(function (w) {
      if (w === OF) { if (groepen.length > 0) orVolgende = true; return; }
      if (STOP.indexOf(w) > -1) return;
      var vormen = MAATVORMEN[w] || varianten(w);
      if (ALGEMEEN[zonderAccent(w)] || ALGEMEEN[zonderAccent(stam(w))]) vormen.algemeen = true;
      if (orVolgende && groepen.length > 0) {
        vormen.forEach(function (v) { if (groepen[groepen.length - 1].indexOf(v) < 0) groepen[groepen.length - 1].push(v); });
      } else {
        var g = vormen.filter(function (v, k) { return vormen.indexOf(v) === k; });
        g.algemeen = vormen.algemeen;
        groepen.push(g);
      }
      orVolgende = false;
    });
    // algemene woorden (lamp, bulb, ampoule, Leuchte ...) alleen meetellen als er verder niets gezocht wordt
    var specifiek = groepen.filter(function (g) { return !g.algemeen; });
    if (specifiek.length) groepen = specifiek;
    return groepen.length ? groepen : null;
  }
  function groepTekst(alts) {
    // eerste vorm (wat de klant typte) ook op tag en producttype, synoniemen alleen op de titel (houdt de zoekopdracht kort)
    return '(' + alts.map(function (w, i) {
      return i === 0 ? 'title:' + w + '* OR tag:' + w + ' OR product_type:' + w : 'title:' + w + '*';
    }).join(' OR ') + ')';
  }

  // Geeft de strakke zoekopdracht, of null als die niet veilig gemaakt kan worden (dan zoekt de winkel zoals voorheen).
  function bouw(raw) {
    var g = groepenVan(raw);
    return g ? g.map(groepTekst).join(' ') : null;
  }
  // Ruimste vangnet: producten die op minstens één van de woorden lijken (Shopify zet de beste overeenkomst bovenaan).
  function ruim(raw) {
    var g = groepenVan(raw);
    return g && g.length > 1 ? g.map(groepTekst).join(' OR ') : null;
  }
  window.lpStrikt = bouw;
  window.lpRuim = ruim;

  // Live resultaten (zoeksuggesties tijdens het typen): ook daar maat en eenheid gelijktrekken,
  // zodat "62 x 62", "62x62cm" en "620x620" dezelfde panelen tonen. Bij een maat wordt ook op tags gezocht.
  function maatTerm(raw) { MAATVORMEN = {}; return maatTekst(ontSyntax(raw)).replace(/\s+/g, ' ').trim(); }
  window.lpMaatTerm = maatTerm;
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('predictive-search').then(function () {
      var C = customElements.get('predictive-search');
      if (!C || !C.prototype.getResults || C.prototype.lpMaat) return;
      var origineel = C.prototype.getResults;
      C.prototype.getResults = function (zoekterm) {
        var term = maatTerm(zoekterm);
        if (!/\d+(\.\d+)?x\d|ø\d/.test(term)) return origineel.call(this, term);
        var instellingen = (window.theme && window.theme.settings) || {};
        var tagsAan = instellingen.pSearchIncludeTags;
        instellingen.pSearchIncludeTags = true;
        try { return origineel.call(this, term); } finally { instellingen.pSearchIncludeTags = tagsAan; }
      };
      C.prototype.lpMaat = true;
    });
  }

  // Live zoeken van LEDPLANET (assets/lp-site.js) haalt resultaten via /search/suggest: ook daar maat en eenheid
  // gelijktrekken ("driver 12 volt" zoekt als "driver 12v"), zonder lp-site.js zelf aan te passen.
  if (window.fetch && !window.fetch.lpZoek) {
    var echteFetch = window.fetch;
    var lpFetch = function (bron, opties) {
      try {
        if (typeof bron === 'string' && /\/search\/suggest/.test(bron)) {
          var u = new URL(bron, window.location.origin), q = u.searchParams.get('q');
          var n = q ? maatTerm(q) : '';
          if (n && n !== q) { u.searchParams.set('q', n); bron = u.pathname + u.search; }
        }
      } catch (e) { /* adres ongemoeid laten */ }
      return echteFetch.call(this, bron, opties);
    };
    lpFetch.lpZoek = true;
    window.fetch = lpFetch;
  }

  function isZoekPad(pad) { return /\/search$/.test(String(pad || '').split('?')[0]); }

  // Formulieren: alleen de verstuurde gegevens worden aangepast, het invoerveld blijft zoals getypt.
  document.addEventListener('formdata', function (evt) {
    var form = evt.target;
    if (!form || !form.getAttribute || !isZoekPad(form.getAttribute('action'))) return;
    var raw = ontSyntax((evt.formData.get('q') || '').toString()).trim();
    var strikt = bouw(raw);
    if (!strikt) { if (raw) evt.formData.set('q', raw); return; }
    evt.formData.set('q', strikt);
    evt.formData.set('term', raw);
  });

  // Links (recent gezocht, zoeksuggesties, "alle resultaten"): href aanpassen zodra ze op de pagina komen.
  function pasLinkAan(a) {
    try {
      var href = a.getAttribute('href');
      if (!href) return;
      var u = new URL(href, window.location.origin);
      if (!isZoekPad(u.pathname) || u.searchParams.has('term') || u.searchParams.has('fb')) return;
      var q = u.searchParams.get('q');
      if (!q) return;
      q = ontSyntax(q).trim();
      if (!q) return;
      var strikt = bouw(q);
      u.searchParams.set('q', strikt || q);
      if (strikt) {
        u.searchParams.set('term', q);
        u.searchParams.set('options[prefix]', 'last');
      }
      a.setAttribute('href', u.pathname + u.search);
      // ook de zichtbare tekst van een suggestie met omgezette zoekopdracht netjes maken
      if (/(title|tag|product_type)\s*:/i.test(a.textContent || '')) a.textContent = q;
    } catch (e) { /* laat de link ongemoeid */ }
  }
  function pasLinksAan(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches('a[href*="/search?"]')) pasLinkAan(root);
    if (root.querySelectorAll) root.querySelectorAll('a[href*="/search?"]').forEach(pasLinkAan);
  }
  new MutationObserver(function (muts) {
    muts.forEach(function (m) { m.addedNodes.forEach(pasLinksAan); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { pasLinksAan(document.body); });
  } else {
    pasLinksAan(document.body);
  }
})();

if (!customElements.get('search-form')) {
  class SearchForm extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.js-search-input');
      this.productTypeSelect = this.querySelector('.js-search-product-types');
      this.productTypeInput = document.getElementById('product_type_input');
      this.resetBtn = this.querySelector('.js-search-reset');
      this.addListeners();
      this.init();
    }

    addListeners() {
      this.input.addEventListener('input', debounce(this.handleInput.bind(this)));
      if (this.productTypeSelect) {
        this.productTypeSelect.addEventListener('change', this.handleProductTypeChange.bind(this));
      }
      this.resetBtn.addEventListener('click', this.handleReset.bind(this));
    }

    init() {
      if ((this.input.dataset.placeholderTwo || this.input.dataset.placeholderThree)
        && (this.input.dataset.placeholderPromptsMob === 'true' || theme.mediaMatches.md)) {
        this.typeInPlaceholders();
      }
      this.restoreTermAndFallback();
    }

    /**
     * Op de zoekpagina: toon de originele zoekterm in het invoerveld (nooit de omgezette zoekopdracht)
     * en zoek ruimer als er niets gevonden is: eerst breed (fb=1), daarna op zoveel mogelijk woorden (fb=2).
     */
    restoreTermAndFallback() {
      if (this.input.id !== 'main-search') return;
      const params = new URLSearchParams(window.location.search);
      const q = params.get('q') || '';
      const ontSyntax = window.lpOntSyntax || ((s) => s);
      const term = (params.get('term') || ontSyntax(q)).trim();
      if (!term) return;
      const pad = window.location.pathname;

      // oude link met omgezette zoekopdracht (bv. uit een zoeksuggestie): eerst opnieuw strak zoeken met de gewone term
      if (!params.get('term') && term !== q && window.lpStrikt) {
        const strikt = window.lpStrikt(term);
        if (strikt) {
          window.location.replace(`${pad}?q=${encodeURIComponent(strikt)}&term=${encodeURIComponent(term)}&options%5Bprefix%5D=last`);
          return;
        }
      }

      if (term !== q) {
        this.input.value = term;
        this.input.setAttribute('value', term);
        this.input.classList.add('search__input--dirty');
        // ook in teksten op de pagina (bv. "Keine Ergebnisse gefunden für ...") en de paginatitel de gewone zoekterm tonen
        const vervang = (s) => String(s).split(q).join(term).split(q.toLowerCase()).join(term);
        const main = document.querySelector('.cc-main-search') || document.querySelector('main') || document.body;
        const walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT);
        let n;
        while ((n = walker.nextNode())) {
          if (/(title|tag|product_type)\s*:/i.test(n.nodeValue)) n.nodeValue = vervang(n.nodeValue);
        }
        if (/(title|tag|product_type)\s*:/i.test(document.title)) document.title = vervang(document.title);
      }

      const noResults = document.querySelector('.cc-main-search p[role="status"]');
      if (!noResults) return;
      const fb = params.get('fb');
      if (!fb) {
        window.location.replace(`${pad}?q=${encodeURIComponent(term)}&term=${encodeURIComponent(term)}&options%5Bprefix%5D=last&fb=1`);
      } else if (fb === '1' && window.lpRuim) {
        const ruim = window.lpRuim(term);
        if (ruim) window.location.replace(`${pad}?q=${encodeURIComponent(ruim)}&term=${encodeURIComponent(term)}&options%5Bprefix%5D=last&fb=2`);
      }
    }

    /**
     * Simulates the placeholder titles being typed in and the previous one deleted, on repeat
     */
    typeInPlaceholders() {
      const typingSpeed = this.input.dataset.typingSpeed || 100;
      const deletingSpeed = this.input.dataset.deletingSpeed || 60;
      const delayAfterDeleting = this.input.dataset.delayAfterDeleting || 500;
      const delayBeforeFirstDelete = this.input.dataset.delayBeforeFirstDelete || 2000;
      const delayAfterWordTyped = this.input.dataset.delayAfterWordTyped || 2400;
      const placeholders = [];

      if (this.input.placeholder) {
        placeholders.push(this.input.placeholder);
      }

      if (this.input.dataset.placeholderTwo) {
        placeholders.push(this.input.dataset.placeholderTwo);
      }

      if (this.input.dataset.placeholderThree) {
        placeholders.push(this.input.dataset.placeholderThree);
      }

      const typeInNextPlaceholder = async (placeholder) => {
        await new Promise((resolve) => {
          let currentPlaceholder = this.input.getAttribute('placeholder');

          // If necessary remove the start of the word to type in if it already exists in the
          // placeholder
          let nextPlaceholder = (currentPlaceholder.length >= 3
              && placeholder.startsWith(currentPlaceholder))
            ? placeholder.replace(currentPlaceholder, '')
            : placeholder;

          const typingIntervalId = setInterval(() => {
            currentPlaceholder = this.input.getAttribute('placeholder');
            this.input.setAttribute('placeholder', currentPlaceholder + nextPlaceholder.charAt(0));
            if (nextPlaceholder.length === 1) {
              resolve();
              clearInterval(typingIntervalId); // Stop typing
            } else {
              nextPlaceholder = nextPlaceholder.substring(1);
            }
          }, typingSpeed);
        });
      };

      const deleteCurrentPlaceholder = async (nextPlaceholder) => {
        await new Promise((resolve) => {
          let prevPlaceholder = this.input.getAttribute('placeholder');
          const deletionIntervalId = setInterval(() => {
            const newPlaceholder = prevPlaceholder.substring(0, prevPlaceholder.length - 1);
            this.input.setAttribute('placeholder', newPlaceholder);
            prevPlaceholder = newPlaceholder;
            if (prevPlaceholder.length === 0
              || (prevPlaceholder.length >= 3 && nextPlaceholder.startsWith(prevPlaceholder))) {
              resolve();
              clearInterval(deletionIntervalId);
            }
          }, deletingSpeed);
        });
      };

      let startIndex = 0;
      const showNextPlaceholder = () => {
        startIndex = (startIndex + 1) % placeholders.length;
        const nextPlaceholder = placeholders[startIndex];
        deleteCurrentPlaceholder.call(this, nextPlaceholder).then(() => {
          setTimeout(() => {
            typeInNextPlaceholder.call(this, nextPlaceholder).then(() => {
              setTimeout(showNextPlaceholder.bind(this), delayAfterWordTyped);
            });
          }, delayAfterDeleting);
        });
      };

      setTimeout(showNextPlaceholder.bind(this), delayBeforeFirstDelete);
    }

    /**
     * Handles 'input' events on the search field.
     */
    handleInput() {
      if (this.input.value.length > 0) {
        this.input.classList.add('search__input--dirty');
      } else {
        this.input.classList.remove('search__input--dirty');
      }
    }

    /**
     * Handles a change of product type
     * @param {object} evt - Event object.
     */
    handleProductTypeChange(evt) {
      this.productTypeInput.value = evt.detail.selectedValue;
    }

    /**
     * Handles the reset button being clicked
     */
    handleReset() {
      this.input.classList.remove('search__input--dirty');
    }
  }

  customElements.define('search-form', SearchForm);
}
